import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import PlusMinusWrapper from './plusMinusWrapper.tsx'
import DecimalInput from './decimalInput.tsx'

// A caller that passes a fractional step (e.g. 0.1) but forgets a matching
// decimals prop would otherwise get decimals=0, which blocks typing "." or ","
// entirely -- so an unset decimals falls back to the precision step itself implies.
const decimalsInStep = (step) => {
  const stepString = String(step)
  const dotIndex = stepString.indexOf('.')
  return dotIndex === -1 ? 0 : stepString.length - dotIndex - 1
}

const IntervalInput = ({
  label,
  value,
  name,
  onChange,
  afterText,
  mandatory,
  tooltipText = '',
  decimals,
  step= 5,
  classNames,
  error
}) => {
  const resolvedDecimals = decimals ?? decimalsInStep(step)
  const mandatoryClass = mandatory ? 'mandatory' : ''
  return (
    <div className={`form-group adjustable-group ${classNames} ${error ? 'error-state' : ''}`}>
      <div className={`form-control ${error ? 'mb-2' : ''}`}>
        <div className={`black-label ${mandatoryClass}`}>
          {label}
        </div>
        <Tooltip title={tooltipText} placement='top' className='task-parameter' arrow>
          <div>
            <PlusMinusWrapper
              name={name}
              step={step}
              value={value}
              onChange={(_, newValue) => onChange(name, newValue)}
            >
              <div className='subwrapper'>
                <DecimalInput
                  className={afterText ? 'with-unit-offset' : ''}
                  name={name}
                  value={value}
                  decimals={resolvedDecimals}
                  emptyValue={null}
                  onChange={onChange}
                />
                <span className='input-unit'>{afterText}</span>
              </div>
            </PlusMinusWrapper>
          </div>
        </Tooltip>
      </div>
      {error && <div className="error-text">{error}</div>}
    </div>
  )
}

export default IntervalInput
